// extracted by mini-css-extract-plugin
export default {"suspenseLoader":"SuspenseLoader_suspenseLoader__hqfVW","decor":"SuspenseLoader_decor__8eM3W"};